import { MoneddSettingsResponse, PixAlertsResponse, PixChargeResponse, PixReportResponse, PublicPixResponse, } from '@aeris/contracts';
import { formatMoney, money } from '@aeris/money';
import { request } from "./client.js";
export const createPixCharge = async (input) => PixChargeResponse.parse(await request('/api/v1/pix-charges', { method: 'POST', body: input })).charge;
/** O servidor pergunta à Monedd quando ainda está pendente. */
export const fetchPixCharge = async (id, signal) => PixChargeResponse.parse(await request(`/api/v1/pix-charges/${id}`, { signal })).charge;
export const fetchMoneddSettings = async (signal) => MoneddSettingsResponse.parse(await request('/api/v1/integrations/monedd', { signal }));
export const saveMoneddSettings = async (input) => MoneddSettingsResponse.parse(await request('/api/v1/integrations/monedd', { method: 'PUT', body: input }));
export const removeMoneddSettings = async () => MoneddSettingsResponse.parse(await request('/api/v1/integrations/monedd', { method: 'DELETE' }));
/** O sininho: os pagos que ninguém viu, da filial da sessão (F205). */
export const fetchUnseenPix = async (signal) => PixAlertsResponse.parse(await request('/api/v1/pix-charges/unseen', { signal }));
export const acknowledgePixCharge = async (id) => {
    await request(`/api/v1/pix-charges/${id}/acknowledge`, { method: 'POST' });
};
export const fetchPixReport = async (query, signal) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
        if (typeof value === 'string' && value !== '')
            params.set(key, value);
        else if (typeof value === 'number')
            params.set(key, String(value));
    }
    const suffix = params.size === 0 ? '' : `?${params.toString()}`;
    return PixReportResponse.parse(await request(`/api/v1/reports/pix${suffix}`, { signal }));
};
/** A página pública de pagamento (F207): sem sessão, pelo token do link. */
export const fetchPublicPix = async (token, signal) => PublicPixResponse.parse(await request(`/api/v1/public/pix/${encodeURIComponent(token)}`, {
    signal,
}));
export const publicPixLogoUrl = (token) => `/api/v1/public/pix/${encodeURIComponent(token)}/logo`;
/**
 * As duas mensagens do Pix, como no sistema antigo (F207): primeiro o link de
 * pagamento, depois o copia-e-cola sozinho — o cliente segura a segunda e
 * copia, sem arrastar o texto do link junto.
 */
export const pixMessages = (charge) => [
    charge.paymentUrl === null
        ? `Segue o Pix de *${formatMoney(money(charge.amount))}*.`
        : `Segue o link para pagamento de *${formatMoney(money(charge.amount))}*:\n${charge.paymentUrl}`,
    `📋 PIX Copia e Cola:\n${charge.copyPaste}`,
];
/** As duas numa só, para quem quer editar antes de mandar. */
export const pixMessage = (charge) => pixMessages(charge).join('\n\n');
//# sourceMappingURL=pix-charges.js.map